// Define the internship API domain
export const internshipDomain = process.env.REACT_APP_NODE_ENV === "development"
  ? "http://localhost:5072"
  : "https://internship.vectorindia.org/api";

// Define the PhonePe payment domain
export const phonepeDomain = process.env.REACT_APP_NODE_ENV === "development"
  ? "http://localhost:5072"
  : "https://vectorindia.org/phonepe";

// Export the internship domain as default for backward compatibility
export default internshipDomain;